import { REGISTER_PARTICIPANT_ERROR, REGISTER_PARTICIPANT_REQUEST, REGISTER_PARTICIPANT_SUCCESS, REGISTER_PARTICIPANT_SET_INIT_MODE } from "../Const/const"
import ContestApi from "../ReduxApi/contestApi";

export const registerParticipantAction = (contestId, userId) => async (dispatch) => {
    dispatch({
        type: REGISTER_PARTICIPANT_REQUEST
    })
    
    const contest = await ContestApi.registerParticipant(contestId, userId)
    console.clear()
    if (contest?.status === 200 || contest?.status === 201) {
        const data = contest.objectVal ? contest.objectVal : { isRegistered: false, participantId: null }
        dispatch({
            type: REGISTER_PARTICIPANT_SUCCESS,
            payload: data
        })
    }else{
        dispatch({
            type: REGISTER_PARTICIPANT_ERROR
        })
    }
}

export const registerParticipantResetAction = () => async (dispatch)  => {
    dispatch({
        type: REGISTER_PARTICIPANT_SET_INIT_MODE,
        payload: { isRegistered: false, participantId: null }
    })
}

